import React from 'react';
import ReportPage from './components/ReportPage';
import WorkflowsByApproversList from './components/WorkflowsByApproversList';
import { useAppSelector } from '../../hooks';

function WorkflowsByApprovers() {
  const currentUser = useAppSelector((state) => state.auth);
  return (
    <ReportPage title="Workflows by approvers">
      <WorkflowsByApproversList currentUser={currentUser} />
    </ReportPage>
  );
}

export default WorkflowsByApprovers;
